import { render } from "./PendingLiquidation.vue?vue&type=template&id=7a37e8cb"
import script from "./PendingLiquidation.vue?vue&type=script&lang=js"
export * from "./PendingLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__